import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { Box, Modal, Typography } from '@ublend-npm/aulaui-core';
import { LTI_CONSUMER } from '@core/constants/endpoints';
import { ExtensionAssignment, ExtensionUser } from './ManageExtension.types';

type Props = {
  assignment: ExtensionAssignment;
  onClose: () => void;
  spaceId: string;
  user: ExtensionUser;
};

const TurnitinExtensionModal = ({
  assignment,
  onClose,
  spaceId,
  user,
}: Props) => {
  const [isLoading, setIsLoading] = useState(true);
  const iframeName = useMemo(
    () => `turnitin-extension-${Math.random().toString(36).slice(2)}`,
    []
  );

  useEffect(() => {
    let isActive = true;
    const launch = async () => {
      const { data } = await axios.post(
        LTI_CONSUMER(),
        {
          assignmentId: assignment.objectId || assignment.id,
          spaceId,
          title: assignment.title,
          description: assignment.description,
          dueDate: assignment.endDate,
          startDate: assignment.startDate,
          gradesReleasedAt: assignment.gradesReleasedAt,
          email: user.email,
          firstName: user.firstName,
          lastName: user.lastName,
        },
        { withCredentials: true }
      );
      if (!isActive) return;
      const form = document.createElement('form');
      form.method = data.method;
      form.action = data.url;
      Object.entries(data.body || {}).forEach(([name, value]) => {
        const input = document.createElement('input');
        input.name = name;
        input.value = String(value);
        form.appendChild(input);
      });
      form.target = iframeName;
      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    };
    launch().catch(() => isActive && setIsLoading(false));
    return () => {
      isActive = false;
    };
  }, [assignment, iframeName, spaceId, user]);

  return (
    <Modal open onClose={onClose}>
      <Box
        sx={{
          bgcolor: 'background.paper',
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100vh - 48px)',
          margin: '24px',
          overflow: 'hidden',
        }}
      >
        <Typography component="h2" sx={{ fontSize: '20px', p: '20px' }}>
          Turnitin: {assignment.title}
        </Typography>
        {isLoading && (
          <Typography sx={{ p: '20px' }}>Loading Turnitin…</Typography>
        )}
        <iframe
          title="turnitin"
          name={iframeName}
          onLoad={() => setIsLoading(false)}
          style={{ border: 0, flex: 1, width: '100%' }}
        />
      </Box>
    </Modal>
  );
};

export default TurnitinExtensionModal;
